<script setup lang="ts">
import { useRouter } from "vue-router";
import { ROUTE_NAMES } from "@/constants/routeNames";
import { useI18n } from "vue-i18n";

const router = useRouter();

const { t } = useI18n();

function goToBlogPage() {
  router.push({ name: ROUTE_NAMES.BLOG_LIST });
}
</script>

<template>
  <button
    class="group flex items-center xl:w-[167px] xl:h-[64px] h-[56px] w-[127px] text-white sf-pro-sm"
    @click="goToBlogPage"
  >
    <span
      class="flex-1 h-full grid place-items-center bg-active transition-[background-color] duration-300 group-hover:bg-brown"
    >
      {{ t("pages.home.header.blog") }}
    </span>

    <span
      class="relative xl:w-[64px] w-[56px] h-full grid place-items-center overflow-hidden"
    >
      <span class="absLayer grad-arrow-normal group-hover:opacity-0"></span>
      <span
        class="absLayer grad-arrow-hover opacity-0 group-hover:opacity-100"
      ></span>

      <img
        src="../../assets/icons/arrow-up-right.svg"
        alt="arrow"
        class="relative z-10 w-6 h-6 transition-transform duration-300 ease-in-out group-hover:rotate-45"
      />
    </span>
  </button>
</template>

<style scoped>
.absLayer {
  position: absolute;
  inset: 0;
  transition: opacity 0.3s ease;
}
</style>
